module.exports = __webpack_public_path__ + "assets/readme.da431b1d.svg";